package components

import api.BackendHealthResponse

data class BackendStatusSnapshot(
    val state: BackendStatusState,
    val detail: String? = null
)

enum class BackendStatusState {
    CHECKING,
    HEALTHY,
    UNAVAILABLE
}

fun buildBackendStatusSnapshot(response: BackendHealthResponse): BackendStatusSnapshot {
    return if (response.status.equals("healthy", ignoreCase = true)) {
        BackendStatusSnapshot(
            state = BackendStatusState.HEALTHY,
            detail = "バックエンドは正常に応答してる。"
        )
    } else {
        BackendStatusSnapshot(
            state = BackendStatusState.UNAVAILABLE,
            detail = "health endpoint は返ってるが、状態は ${response.status} だった。"
        )
    }
}

fun buildBackendUnavailableMessage(error: Throwable): String {
    val message = error.message.orEmpty()

    return when {
        message.contains("timeout", ignoreCase = true) ->
            "health check がタイムアウトした。起動直後かネットワーク不安定の可能性がある。"
        message.contains("Backend unavailable", ignoreCase = true) ->
            "バックエンドに接続できなかった。`make dev-status` と `make dev-health` を確認してくれ。"
        else ->
            "バックエンドに接続できなかった。ローカル開発中なら起動状態を確認してくれ。"
    }
}

fun buildBackendStatusTitle(
    snapshot: BackendStatusSnapshot,
    newsError: Throwable?
): String {
    return when {
        snapshot.state == BackendStatusState.CHECKING ->
            "バックエンド接続を確認中"
        snapshot.state == BackendStatusState.UNAVAILABLE ->
            "バックエンドが不安定"
        newsError != null ->
            "バックエンドは生きてるが、ニュース取得で失敗"
        else ->
            "バックエンドは正常"
    }
}

fun buildBackendStatusMessage(
    snapshot: BackendStatusSnapshot,
    newsError: Throwable?
): String {
    return when {
        snapshot.state == BackendStatusState.CHECKING ->
            "health endpoint に疎通確認してる。起動直後は数秒かかることがある。"
        snapshot.state == BackendStatusState.UNAVAILABLE ->
            snapshot.detail ?: "バックエンドに接続できなかった。"
        newsError != null ->
            "health は正常応答だが、ニュース取得は失敗した。GraphQL error と backend ログを確認してくれ。"
        else ->
            snapshot.detail ?: "API は応答中だ。このままニュースを取得できる。"
    }
}

fun buildBackendStatusTone(
    snapshot: BackendStatusSnapshot,
    newsError: Throwable?
): String {
    return when {
        snapshot.state == BackendStatusState.CHECKING -> "checking"
        snapshot.state == BackendStatusState.UNAVAILABLE -> "offline"
        newsError != null -> "warning"
        else -> "healthy"
    }
}
